import { ITutorial } from "../../../models/ITutorial";
import {IUser} from "../../../models/IUser";
import {ICpuStory} from "../../../models/ICpuStory";
import {IMusic} from "../../../models/IMusic";
import {IBoxArray} from "../../../models/IBoxArray";
import {INutakuBoxArray} from "../../../models/INutakuBoxArray";
import {ISystemMessage} from "../../../models/ISystemMessage";
import {IDeckEditorFilter} from "../../../models/IDeckEditorFilter";
import {IVersionError} from "../../../models/IVersionError";

export interface AuthState {
    route: string;
    uniqId: string;
    isAuth: boolean;
    user: IUser;
    isLoading: boolean;
    error: string;
    tutorial: ITutorial;
    cpuStory: ICpuStory;
    music: IMusic;
    boxes: IBoxArray;
    nutakuBoxes: INutakuBoxArray;
    openBox: any;
    cards: any; // all cards in game
    promoSocial: boolean; // promo popup on map
    cardBigSize: any;
    systemMessage: ISystemMessage,
    inQueue: boolean,
    deckEditorFilter: IDeckEditorFilter,
    globalLoading: boolean,
    globalError: IVersionError | string | null;
}

export enum AuthActionEnum {
    SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR",
    SET_GLOBAL_LOADING = "SET_GLOBAL_LOADING",
    SET_UNIQ_ID = "SET_UNIQ_ID",
    SET_ROUTE = "SET_ROUTE",
    SET_IS_LOADING = "SET_IS_LOADING",
    SET_AUTH = "SET_AUTH",
    SET_ERROR = "SET_ERROR",
    SET_USER = "SET_USER",
    SET_TUTORIAL = "SET_TUTORIAL",
    SET_CPU_STORY = "SET_CPU_STORY",
    SET_MUSIC = "SET_MUSIC",
    SET_BOXES = "SET_BOXES",
    SET_NUTAKU_BOXES = "SET_NUTAKU_BOXES",
    SET_OPENBOX = 'SET_OPENBOX',
    SET_CARDS = 'SET_CARDS',
    SET_PROMO_SOCIAL = "SET_PROMO_SOCIAL",
    SET_CARD_BIG_SIZE ="SET_CARD_BIG_SIZE",
    SET_SYSTEM_MESSAGE = "SET_SYSTEM_MESSAGE",
    SET_IN_QUEUE = "SET_IN_QUEUE",
    SET_DECK_EDITOR_FILTER = "SET_DECK_EDITOR_FILTER",
}

export interface SetDeckEditorFilter {
    type: AuthActionEnum.SET_DECK_EDITOR_FILTER;
    payload:IDeckEditorFilter;
}

export interface SetGlobalErrorAction {
    type: AuthActionEnum.SET_GLOBAL_ERROR;
    payload: IVersionError | string | null;
}

export interface SetGlobalLoadingAction {
    type: AuthActionEnum.SET_GLOBAL_LOADING;
    payload: boolean;
}

export interface SetUniqIdAction {
    type: AuthActionEnum.SET_UNIQ_ID;
    payload: string;
}

export interface SetRouteAction {
    type: AuthActionEnum.SET_ROUTE;
    payload: string;
}

export interface SetAuthAction {
    type: AuthActionEnum.SET_AUTH;
    payload: boolean;
}
export interface SetErrorAction {
    type: AuthActionEnum.SET_ERROR;
    payload: string;
}
export interface SetUserAction {
    type: AuthActionEnum.SET_USER;
    payload: IUser;
}
export interface SetTutorialAction {
    type: AuthActionEnum.SET_TUTORIAL;
    payload: ITutorial;
}
export interface SetIsLoadingAction {
    type: AuthActionEnum.SET_IS_LOADING;
    payload: boolean;
}
export interface SetCpuStoryAction {
    type: AuthActionEnum.SET_CPU_STORY;
    payload: ICpuStory;
}

export interface SetMusicAction {
    type: AuthActionEnum.SET_MUSIC,
    payload: IMusic;
}

export interface SetBoxesAction {
    type: AuthActionEnum.SET_BOXES,
    payload: IBoxArray;
}

export interface SetNutakuBoxesAction {
    type: AuthActionEnum.SET_NUTAKU_BOXES,
    payload: INutakuBoxArray;
}

export interface SetOpenBox {
    type: AuthActionEnum.SET_OPENBOX,
    payload: any
}

export interface SetCards {
    type: AuthActionEnum.SET_CARDS,
    payload: any
}

export interface SetPromoSocilaAction {
    type: AuthActionEnum.SET_PROMO_SOCIAL,
    payload: boolean;
}

export interface  SetCardBigSize {
    type: AuthActionEnum.SET_CARD_BIG_SIZE,
    payload: any
}

export interface  SetSystemMessage {
    type: AuthActionEnum.SET_SYSTEM_MESSAGE,
    payload: ISystemMessage
}

export  interface  SetInQueue {
    type: AuthActionEnum.SET_IN_QUEUE,
    payload: boolean
}

export type AuthAction =
    SetUniqIdAction |
    SetRouteAction |
    SetAuthAction |
    SetUserAction |
    SetErrorAction |
    SetIsLoadingAction |
    SetTutorialAction |
    SetCpuStoryAction |
    SetMusicAction |
    SetBoxesAction |
    SetNutakuBoxesAction |
    SetOpenBox |
    SetCards |
    SetPromoSocilaAction |
    SetCardBigSize |
    SetSystemMessage |
    SetInQueue |
    SetDeckEditorFilter |
    SetGlobalLoadingAction |
    SetGlobalErrorAction
